import { render, staticRenderFns } from "./EditProviderAdditionalFee.vue?vue&type=template&id=20dd3ed0"
import script from "./EditProviderAdditionalFee.vue?vue&type=script&lang=js"
export * from "./EditProviderAdditionalFee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports